<template>

<div class="modal-wrapper" :class="{'is-prompt': prompt}">
        
    <div class="modal" :class="{'is-loading': loading}">

        <div class="modal-head" v-show="!loading">

            <div class="modal-head-title">{{ title }}</div>
            <div class="modal-head-description" v-if="description">{{ description }}</div>

            <app-icon name="remove" class="modal-head-close" v-on:click.native="$emit('close')" v-if="!prompt || forceClose" />

        </div>

        <div class="modal-content" v-show="!loading && !prompt">

            <slot></slot>

        </div>

        <app-group :row="true" class="modal-foot" v-show="!loading">

            <slot name="foot"></slot>

        </app-group>

    </div>

</div>

</template>

<script>

export default {

    props: ['title', 'description', 'loading', 'prompt', 'forceClose']
    
}

</script>

<style scoped>

.modal-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    right: 0px;
    z-index: 100001;
    background-color: rgba(0, 0, 0, 0.75);
}

.modal-wrapper.is-prompt {
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
}

.modal {
    position: fixed;
    width: 320px;
    height: 100%;
    top: 0px;
    right: 0px;
    z-index: 1000;
    background-color: #fff;
    border-left: 1px solid var(--color-grey-light);
    display: flex;
    flex-direction: column;
	overflow-y: scroll;
}

.is-mobile .modal {
    width: 100%;
    bottom: 0px;
    overflow-y: scroll;
}

.modal-wrapper.is-prompt .modal {
    left: 50%;
    top: 50%;
    width: 480px;
    max-width: 100%;
	bottom: auto;
	right: auto;
	border-left-width: 0px;
    height: auto;
    transform: translate(-50%, -50%);
}

.modal.is-loading {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-image: url(~@/assets/app.load.gif)
}

.modal-head {
    padding: 15px;
    border-bottom: 1px solid var(--color-grey-light);
    flex-shrink: 0;
    min-height: 64px;
}

.modal-wrapper.is-prompt .modal-head {
	border-bottom-width: 0px;
}

.modal-head-close {
    display: block;
    width: 48px;
    height: 48px;
    line-height: 48px;
    font-size: 24px;
    text-align: center;
    position: absolute;
    right: 0px;
    top: 0px;
    color: #fff;
    background-color: var(--color-blue-light);
    cursor: pointer;
}

.is-desktop .modal-head-close:hover {
    background-color: var(--color-blue-dark);
}

.modal-head-title {
    font-weight: 700;
    font-size: 24px;
    padding-right: 56px;
    color: var(--color-grey-dark);
}

.modal-wrapper.is-prompt .modal-head-title {
    padding-right: 0px;
    text-align: center;
}

.modal-head-description {
    font-weight: 300;
    margin-top: 15px;
    font-size: 14px;
    line-height: 18px;
    color: var(--color-grey-dark);
}

.modal-wrapper.is-prompt .modal-head-description {
    text-align: center;
}

.modal-content {
    padding: 15px;
    flex-grow: 1;
    flex-basis: 0;
}

.modal-foot {
    padding: 15px 10px;
    border-top: 1px solid var(--color-grey-light);
    flex-shrink: 0;
}

.modal-wrapper.is-prompt .modal-foot {
	border-top-width: 0px;
}

.modal-foot >>> .button {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    margin: 0px 5px;
}

.modal-foot >>> .button-wrapper {
    justify-content: center;
}

</style>